import React, { useMemo } from 'react';
import noop from 'lodash/noop';
import { ButtonWithIcon } from '@els/els-react--button';
import { ZOOM_MIN, ZOOM_MAX, ZOOM_STEP } from '../constants';

function ZoomButtons({ min = ZOOM_MIN, max = ZOOM_MAX, step = ZOOM_STEP, value, onChanged = noop }) {
  // Round next value to 0.1 fixed precision, then ensure it is not greater than max
  const zoomInValue = useMemo(() => Math.min(parseFloat((value + step).toFixed(1)), max), [value, step, max]);
  // Round next value to 0.1 fixed precision, then ensure it is not less than min
  const zoomOutValue = useMemo(() => Math.max(parseFloat((value - step).toFixed(1)), min), [value, step, min]);

  const onZoomIn = () => {
    onChanged(zoomInValue);
  };
  const onZoomOut = () => {
    onChanged(zoomOutValue);
  };

  return (
    <div aria-live="polite">
      <ButtonWithIcon
        data-e2e="rs-toolbar-button-zoom-in"
        layout="vertical"
        sprite="ZoomIn"
        type="borderless"
        size="small"
        className="e2e-rs-toolbar-button-zoom-in"
        disabled={zoomInValue <= value}
        onClick={onZoomIn}
        aria-label={`Zoom in to next level ${zoomInValue}${zoomInValue >= max ? ' (maximum)' : ''}`}>
        Zoom in
      </ButtonWithIcon>
      <ButtonWithIcon
        data-e2e="rs-toolbar-button-zoom-out"
        layout="vertical"
        sprite="ZoomOut"
        type="borderless"
        size="small"
        className="e2e-rs-toolbar-button-zoom-out"
        disabled={zoomOutValue >= value}
        onClick={onZoomOut}
        aria-label={`Zoom out to next level ${zoomOutValue}${zoomOutValue <= min ? ' (minimum)' : ''}`}>
        Zoom out
      </ButtonWithIcon>
    </div>
  );
}

export default ZoomButtons;
